import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=5222e119&scoped=true"
import script from "./EditRules.vue?vue&type=script&lang=js"
export * from "./EditRules.vue?vue&type=script&lang=js"
import style0 from "./EditRules.vue?vue&type=style&index=0&id=5222e119&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222e119",
  null
  
)

export default component.exports